import { DefaultDashboardTabIds } from 'data';
import { IGridColumnProps } from '..';
import { IColumn } from '../types';
import { getApplicationColumns } from './applicationColumns';
import { getApplicantOfferColumns } from './offerColumns';

export const getColumns = (input: IGridColumnProps): IColumn[] => {
  if (input.activeTab === DefaultDashboardTabIds.LEADS) {
    return getApplicationColumns();
  }
  return getApplicantOfferColumns(input);
};
